import React from 'react'
import styled from 'styled-components';

export default function Policy() {
  return (
    <>
    <Container>
    <div className="container">

    
        <h1>Privacy Policy</h1>
    <p>Effective date: 12-june-2023</p>
    <p>At Universal Chat, we value the privacy of our users. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website.</p>

    <h2>Information We Collect</h2>
    <p>We may collect your email address when you voluntarily provide it to us for the purpose of subscribing to our newsletter or contacting us. We do not collect any other personally identifiable information.</p>

    <h2>Use of Your Information</h2>
    <p>We use your email address solely for the purpose of sending newsletters or responding to your inquiries. We do not share your email address with any third parties.</p>

    <h2>Data Security</h2>
    <p>We prioritize the security of your personal information and take reasonable precautions to protect it. However, please note that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

    <h2>External Links</h2>
    <p>Our website may contain links to external websites. We are not responsible for the privacy practices or the content of these external sites.</p>
  
  
    </div>
    </Container>
    </>
  )
};
const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  margin-top: 2%;
  color:#fff;
  
  .container {
    align-items: center;
    text-align:start;
    height: 100%;
    min-height:100vh;
    width: 85vw;
    background-color: #00000076;
    display: grid;
    grid-template-columns:  100% ;

    margin: 0 auto;
    padding: 20px;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }
h2{
    margin: 10px; 
}
  p {
    margin-bottom: 10px;
  }
}
    
    
    `;


